export const languages = [
  {
    name: 'Português',
    level: 'Nativo',
    code: 'pt-BR'
  },
  {
    name: 'Inglês',
    level: 'Intermediário',
    code: 'en-US'
  },
  {
    name: 'Espanhol',
    level: 'Básico',
    code: 'es-ES'
  }
];
